import { render, staticRenderFns } from "./HolidayLet.vue?vue&type=template&id=72616724&scoped=true&"
import script from "./HolidayLet.vue?vue&type=script&lang=ts&"
export * from "./HolidayLet.vue?vue&type=script&lang=ts&"
import style0 from "./HolidayLet.vue?vue&type=style&index=0&id=72616724&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72616724",
  null
  
)

export default component.exports